import styled, { css } from 'styled-components';
export var Title = styled.div.withConfig({
  displayName: "elements__Title",
  componentId: "sc-4yzm9e-0"
})(["grid-area:title;color:", ";font-size:", ";margin-top:0.3rem;"], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.spaceGrey;
}, function (_ref2) {
  var isCompacted = _ref2.isCompacted,
      fonts = _ref2.theme.fonts;
  return isCompacted ? fonts.size["default"] : fonts.size.medium;
});
export var Value = styled.div.withConfig({
  displayName: "elements__Value",
  componentId: "sc-4yzm9e-1"
})(["grid-area:value;color:", ";font-size:", ";font-weight:", ";"], function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.darkBlue;
}, function (_ref4) {
  var isCompacted = _ref4.isCompacted,
      fonts = _ref4.theme.fonts;
  return isCompacted ? fonts.size.h3 : fonts.size.h2;
}, function (_ref5) {
  var fonts = _ref5.theme.fonts;
  return fonts.weight.thick;
});
export var Variation = styled.div.withConfig({
  displayName: "elements__Variation",
  componentId: "sc-4yzm9e-2"
})(["grid-area:variation;align-items:center;display:flex;font-size:", ";right:1rem;top:1rem;justify-self:", ";", ";", ";"], function (_ref6) {
  var fonts = _ref6.theme.fonts;
  return fonts.size["default"];
}, function (_ref7) {
  var isCompacted = _ref7.isCompacted;
  return isCompacted ? 'center' : 'end';
}, function (_ref8) {
  var negative = _ref8.negative;
  return negative && css(["color:", ";"], function (_ref9) {
    var palette = _ref9.theme.palette;
    return palette.failure["default"];
  });
}, function (_ref10) {
  var positive = _ref10.positive;
  return positive && css(["color:", ";"], function (_ref11) {
    var palette = _ref11.theme.palette;
    return palette.success["default"];
  });
});